import pushRoute from '@app/utils/routing';
import { Box } from '@ublend-npm/aulaui-core';
import React from 'react';

type Props = {
  spaceId: string;
};

const AssignmentCard = ({ spaceId }: Props) => {
  const assignmentRoute = `/dashboard/${spaceId}/journey/assignments/169be44a-3ec0-4d41-97d9-4e05381af71e`;

  const onClickAssignment = () => {
    pushRoute(assignmentRoute);
  };

  return <Box onClick={onClickAssignment}>AssignmentCard</Box>;
};

export default AssignmentCard;
